import {AxiosError} from 'axios';
import {} from 'framer-motion';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import {
  ErrorCode,
  getPersianErrorCode,
} from '../../../../global/helpers/ErrorCodes/ErrorCode';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import useGetLoanValidationPrice from '../../../../services/hookService/getLoanValidationPrice/useGetLoanValidationPrice';
import useGetSummerySupplierInfo from '../../../../services/hookService/getSummerySupplierInfo/useGetSummerySupplierInfo';
import usePatchDirectLoanRequest from '../../../../services/hookService/patchDirectLoanRequest/usePatchDirectLoanRequest';
import usePatchLoanRequest from '../../../../services/hookService/patchLoanRequest/usePatchLoanRequest';
import usePostCheckOtpCode from '../../../../services/hookService/postCheckOtpCode/usePostCheckOtpCode';
import usePostLoanValidationRequest from '../../../../services/hookService/postLoanValidationRequest/usePostLoanValidationRequest';
import usePostResendOtpCode from '../../../../services/hookService/postResendOtpCode/usePostSendOtpCode';
import usePostSendOtpCode from '../../../../services/hookService/postSendOtpCode/usePostSendOtpCode';
import {
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../../../myAccount/my-credits/consts/loanStatus';
import {receiveLoanSteps} from '../../receiveLoan/receiveLoanSteps';
import MultiStepComponent from '../MultiStepComponent';
import {receiveCreditSteps} from '../receiveCreditSteps';
import LoanRequestHeader from '../step3-completeDocs/components/LoanRequestHeader';
import {useMultiStepForm} from '../useMultiStepForm';
import OtpModal from './OtpModal';
import BankValidation from './status1/BankValidation';
import FarmValidation from './status1/FarmValidation';
import GetNationalCardIdBottomSheet from './status1/GetNationalCardIdBottomSheet';
import UpgradeAccBtmSheet from './status1/UpgradeAccBtmSheet';
import ValidationsPending from './status2/ValidationsPending';
import BankValidationResult from './status3/BankValidationResult';
import ValidationsResult from './status3/ValidationsResult';

const ValidationPage = () => {
  const navigate = useNavigate();

  const [nationalCardId, setNationalCardId] = useState<string>('');
  const [isOpenGetNationalCardId, setIsOpenGetNationalCardId] =
    useState<boolean>(false);

  const [showWrongCodeError, setShowWrongCodeError] = useState<boolean>(false);
  const [showNationalIdPhoneMismatch, setShowNationalIdPhoneMismatch] =
    useState<boolean>(false);
  const [showDuplicate, setShowDuplicateNationalCode] =
    useState<boolean>(false);
  const [showWrongCodeCount, setShowWrongCodeCount] = useState<number>(0);
  const [BankValidationGuid, setBankValidationGuid] = useState<string>('');

  // Get the list of loan requests
  const {data: listLoanRequest, isLoading: isLoadingListLoanRequest} =
    useGetListLoanRequest({is_finished: false});
  const loanItem = listLoanRequest as ILoanRequestItem | undefined;

  const {stepNumber, goNext} = useMultiStepForm();

  const {
    data: getSummerySupplierInfo,
    isLoading: isLoadingGetSummerySupplierInfo,
  } = useGetSummerySupplierInfo([1].includes(loanItem?.status as number));

  const {mutate: mutatePatchLoan, isLoading: isLoadingPatchLoan} =
    usePatchLoanRequest();

  const {mutate: mutatePatchDirectLoan, isLoading: isLoadingPatchDirectLoan} =
    usePatchDirectLoanRequest();

  const [isOpenValidationModal, setIsOpenValidationModal] = useState(false);

  // ---------------- API hooks ----------------
  const {data: validationPrice, isLoading: isLoadingValidationPrice} =
    useGetLoanValidationPrice();

  const {mutate: mutateSendOtpCode, isLoading: isSendingCodeLoading} =
    usePostSendOtpCode();
  const {mutate: mutateResendOtpCode, isLoading: isReSendingCodeLoading} =
    usePostResendOtpCode();
  const {mutate: mutateCheckOtpCode, isLoading: isLoadingCheckOtpCode} =
    usePostCheckOtpCode();

  const isLoading =
    (isLoadingListLoanRequest && isLoadingValidationPrice) ||
    isLoadingGetSummerySupplierInfo;

  // ---------------- Handlers ----------------
  const handleValidation = () => {
    if (showWrongCodeCount <= 5 && showWrongCodeCount !== 0) {
      handleResendCode();
      if (showWrongCodeCount === 5) setShowWrongCodeCount(0);
      return;
    }
    setIsOpenGetNationalCardId(true);
  };

  const handleResendCode = () => {
    if (!loanItem) return;
    mutateResendOtpCode(BankValidationGuid, {
      onSuccess: () => {
        setIsOpenGetNationalCardId(false);
        setIsOpenValidationModal(true);
      },
    });
  };

  const handleSendCode = () => {
    if (!loanItem) return;
    mutateSendOtpCode(
      {
        national_code: nationalCardId,
      },
      {
        onSuccess: data => {
          setBankValidationGuid(data?.bank_validation);
          setIsOpenGetNationalCardId(false);
          setIsOpenValidationModal(true);
        },
        onError: Error => {
          const ApiCustomErrorCode =
            // @ts-ignore
            Error?.response?.data?.national_code?.error_code;

          if (ApiCustomErrorCode === ErrorCode.DUPLICATED_NATIONAL_CODE_ERROR) {
            setShowDuplicateNationalCode(true);
            setShowWrongCodeError(false);
            setShowNationalIdPhoneMismatch(false);
            setIsOpenGetNationalCardId(false);
            return;
          }
          toast.error('خطا در ارسال کد تایید', {
            position: 'bottom-right',
          });
        },
      },
    );
  };
  const handleSubmitOtpCode = (otp: string) => {
    if (!loanItem) return;

    // refresh errors
    setShowWrongCodeError(false);
    setShowNationalIdPhoneMismatch(false);

    mutateCheckOtpCode(
      {
        otp_code: otp,
        loan_request: loanItem.guid,
      },
      {
        onSuccess: () => {
          setIsOpenValidationModal(false);
          navigate(0); // Reload current route to get latest status
        },
        onError: (error: any) => {
          let ErrorMessage =
            error?.response?.data?.messages?.[0] ||
            error?.response?.data?.message ||
            error?.message ||
            'خطا در ارسال کد تایید';

          if (ErrorMessage === 'رمز یکبار مصرف اشتباه است') {
            setShowWrongCodeError(true);
            return;
          }

          if (ErrorMessage === 'اعتبار رمز یکبارمصرف به پایان رسیده است') {
            setShowWrongCodeCount(showWrongCodeCount + 1);
            setIsOpenValidationModal(false);
          }

          if (ErrorMessage === 'عدم تطابق شماره ملی و شماره تماس') {
            setShowWrongCodeCount(0);
            setShowNationalIdPhoneMismatch(true);
            setIsOpenValidationModal(false);
            setNationalCardId('');
            return;
          }

          toast.error(ErrorMessage, {
            position: 'bottom-right',
          });
        },
      },
    );
  };

  const handleNextStep = () => {
    const payload: IPatchLoanRequestPayload | IPatchDirectLoanRequestPayload = {
      loan_request_guid: loanItem?.guid as string,
      status: 4,
    };

    if (loanItem?.is_direct) {
      mutatePatchDirectLoan(payload, {
        onSuccess: () => goNext(loanItem?.is_direct as boolean),
      });
    } else {
      mutatePatchLoan(payload, {
        onSuccess: () => goNext(loanItem?.is_direct as boolean),
      });
    }
  };

  // ---------------- Render ----------------
  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <LoanRequestHeader
        backPath="/my-credits"
        title="اعتبارسنجی"
        loanRequestGuid={listLoanRequest?.guid}
        showCancelButton={showCancelButtonByLoanStatus(
          listLoanRequest?.status as LoanRequestStatus,
        )}
      />
      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-4 overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <MultiStepComponent
              steps={
                loanItem?.is_direct ? receiveLoanSteps : receiveCreditSteps
              }
              currentStep={stepNumber}
            />

            {loanItem?.status === 1 && (
              <>
                <FarmValidation
                  validationPrice={validationPrice}
                  loanGuid={loanItem?.guid}
                />
                <BankValidation />

                {showNationalIdPhoneMismatch && (
                  <div className="flex gap-1 text-sm font-normal text-red-600">
                    <i className="text-lg icon-warning-triangle" />
                    <span>
                      عدم تطابق کد ملی و مالک شماره. لطفا کد ملی مالک شماره را
                      وارد کنید.
                    </span>
                  </div>
                )}
                {showDuplicate && (
                  <div className="flex gap-1 text-sm font-normal text-red-600">
                    <i className="text-lg icon-warning-triangle" />
                    <span>
                      {getPersianErrorCode(
                        ErrorCode.DUPLICATED_NATIONAL_CODE_ERROR,
                      )}
                    </span>
                  </div>
                )}
              </>
            )}

            {loanItem?.status === 2 && <ValidationsPending />}

            {loanItem?.status === 3 && (
              <div className="flex flex-col gap-6 pb-36">
                <ValidationsResult loanItem={loanItem} />
                <BankValidationResult loanItem={loanItem} />
              </div>
            )}
          </>
        )}
      </div>
      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 z-50 flex flex-col gap-2 bg-white">
        {/* Before Validation */}
        {[1].includes(loanItem?.status as number) && (
          <Button
            className="!px-6 !mx-6"
            size="large"
            onClick={handleValidation}
            disabled={loanItem?.status === 2 || isReSendingCodeLoading}
            isLoading={isReSendingCodeLoading}
          >
            اعتبارسنجی
          </Button>
        )}

        {/* After Validation */}
        {loanItem?.status === 3 && (
          <Button
            className="!px-6 !mx-6"
            size="large"
            onClick={handleNextStep}
            disabled={isLoadingPatchLoan || isLoadingPatchDirectLoan}
            isLoading={isLoadingPatchLoan || isLoadingPatchDirectLoan}
          >
            ادامه
          </Button>
        )}

        <MainFooter isScrolling={false} />
      </div>
      {/* OTP Modal */}
      <OtpModal
        isOpen={isOpenValidationModal}
        setIsOpen={setIsOpenValidationModal}
        isLoading={isLoadingCheckOtpCode}
        otpLength={5}
        onClose={() => setShowWrongCodeCount(showWrongCodeCount + 1)}
        onSubmit={handleSubmitOtpCode}
        onError={() => toast.error('خطایی رخ داده است')}
        Error={
          showWrongCodeError ? ' کد وارد شده صحیح نیست. دوباره تلاش کنید.' : ''
        }
      />
      {/* Bottom Sheet */}

      <GetNationalCardIdBottomSheet
        isOpen={isOpenGetNationalCardId}
        setIsOpen={setIsOpenGetNationalCardId}
        setNationalCardId={setNationalCardId}
        isLoading={isSendingCodeLoading || isReSendingCodeLoading}
        nationalCardId={nationalCardId}
        phoneNumber={getSummerySupplierInfo?.phone_number!}
        onSubmit={handleSendCode}
      />
    </div>
  );
};

export default ValidationPage;
